import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import HighZTooltip from './HighZTooltip';
import { RestrictedHeaderProps } from './types';

const RestrictedHeader: React.FC<RestrictedHeaderProps> = ({
  children,
  isRestricted,
  tooltipMessage = 'Upgrade your plan to see this values',
  showLockIcon = true,
}) => {
  if (!isRestricted || !showLockIcon) {
    return <>{children}</>;
  }

  return (
    <div className="flex items-center gap-1">
      {children}
      <HighZTooltip content={tooltipMessage} position="bottom">
        <div className="cursor-help">
          <LockClosedIcon className="w-4 h-4 text-gray-500" />
        </div>
      </HighZTooltip>
    </div>
  );
};

export default RestrictedHeader;
